import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../header/Header";
import Sidebarr from "../sidebar/Sidebar";
import VendorSidebar from "../sidebar/VendorSidebar";
import Tool from "../sidebar/Tool";
import Footer from "../footer/Footer";
import axios from "../helper/axios";
import { useSelector } from "react-redux";

export default function BrandBannerBrandsList() {
  const auth = useSelector((state) => state.auth);
  const [brands, setBrands] = useState([]);
  const [bannerCounts, setBannerCounts] = useState({});
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const [brandsRes, bannersRes] = await Promise.all([
          axios.get("/getBrands"),
          axios.get("/getbrandbanners")
        ]);

        const brandList = Array.isArray(brandsRes.data) ? brandsRes.data : [];
        setBrands(brandList);

        const counts = {};
        const banners = Array.isArray(bannersRes.data) ? bannersRes.data : [];
        banners.forEach((b) => {
          const slug = String(b.slug || "").toLowerCase();
          if (slug) counts[slug] = (counts[slug] || 0) + 1;
        });
        setBannerCounts(counts);
      } catch (error) {
        console.error("Error loading brands:", error);
        setBrands([]);
      }
      setLoading(false);
    };
    load();
  }, []);

  const filtered = brands.filter((b) => {
    const q = search.trim().toLowerCase();
    if (!q) return true;
    return (
      String(b.brand || "").toLowerCase().includes(q) ||
      String(b.slug || "").toLowerCase().includes(q) ||
      String(b.storeCode || "").toLowerCase().includes(q)
    );
  });

  return (
    <div className="sidebar-mini skin-green-light">
      <div className="wrapper">
        <Header />
        {auth?.user?.role === "Vendor" ? <VendorSidebar /> : <Sidebarr />}

        <div className="content-wrapper">
          <section className="content-header">
            <h1>
              Brand Banners
              <small>zgjidh brandin për të menaxhuar banerat</small>
            </h1>
            <ol className="breadcrumb">
              <li>
                <a href="#">
                  <i className="fa fa-dashboard" /> Home
                </a>
              </li>
              <li className="active">Brand Banners</li>
            </ol>
          </section>

          <section className="content">
            <div className="box">
              <div className="box-header with-border">
                <h3 className="box-title">Të gjithë brandet ({filtered.length})</h3>
              </div>
              <div className="box-body">
                <div className="row" style={{ marginBottom: "15px" }}>
                  <div className="col-xs-4">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Kërko brand, slug ose store code..."
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                    />
                  </div>
                </div>

                {loading && <p>Duke ngarkuar...</p>}

                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th style={{ width: "40px" }}>#</th>
                      <th style={{ width: "80px" }}>Logo</th>
                      <th>Brand</th>
                      <th>Slug</th>
                      <th style={{ width: "120px" }}>Banera</th>
                      <th style={{ width: "130px" }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {filtered.map((b, idx) => {
                      const slug = String(b.slug || "").toLowerCase();
                      const count = bannerCounts[slug] || 0;
                      return (
                        <tr key={b._id || slug || idx}>
                          <td>{idx + 1}</td>
                          <td>
                            {b.brandImage ? (
                              <img
                                src={b.brandImage}
                                alt={b.brand}
                                height="40"
                                width="40"
                                style={{ objectFit: "cover", borderRadius: "4px" }}
                              />
                            ) : (
                              "—"
                            )}
                          </td>
                          <td>{b.brand}</td>
                          <td>
                            <code>{b.slug || "—"}</code>
                          </td>
                          <td>
                            <span className={`label ${count > 0 ? "label-success" : "label-default"}`}>
                              {count}
                            </span>
                          </td>
                          <td>
                            {slug ? (
                              <Link
                                to={`/brandbanners/${slug}`}
                                className="btn btn-primary btn-sm"
                              >
                                <i className="fa fa-image" /> Menaxho
                              </Link>
                            ) : (
                              <span className="text-muted">Pa slug</span>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                    {!loading && filtered.length === 0 && (
                      <tr>
                        <td colSpan="6" className="text-center">
                          Nuk u gjet asnjë brand.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </section>
        </div>

        <Footer />
        <Tool />
        <div className="control-sidebar-bg" />
      </div>
    </div>
  );
}
